import { render } from "./pricing-card.vue?vue&type=template&id=c4377a64&scoped=true&ts=true"
import script from "./pricing-card.vue?vue&type=script&lang=ts"
export * from "./pricing-card.vue?vue&type=script&lang=ts"

import "./pricing-card.vue?vue&type=style&index=0&id=c4377a64&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4377a64"]])

export default __exports__